// extracted by mini-css-extract-plugin
export default {"root":"button_root__3feIc","section":"button_section__QN0hO","skeleton":"button_skeleton__rBhST"};